// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_pages_pages_module_ts":"a6355cd4ef7d7a72","src_assets_mocks_mocks_json":"84f22b759080dc96"}[chunkId] + ".js";
};